import { useTranslation } from 'react-i18next'
import { parseStringToHtml } from '../../utils/parseStringToHtml'

export const TermsHealthData = () => {
  const { t } = useTranslation()

  return <div>{parseStringToHtml(t('terms.child-terms'))}</div>
}
